import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	notificationMessage: {
		padding: theme.spacing(2),
		textAlign: "center",
		display: "inline-block",
		maxWidth: "none"
	},
	blueNotification: {
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[100])
	},
	orangeNotification: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[100])
	},
	grayNotification: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
	},
	whiteNotification: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0])
	},
	messageText: {
		fontSize: 12
	},
	messageContent: {
		position: "relative",
		borderRadius: theme.spacing(1),
		boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.25)",
		wordBreak: "break-word",
		display: "inline-block"
	},
	messageInfoContainer: {
		minHeight: 30,
		display: "flex",
		width: "100%",
		position: "absolute",
		top: 0,
		right: 0
	}
}))

export default useStyles
